export default {
    getMerchantInfo: {
        name: "get merchant info api",
        version: 6,
        url: "info",
        method: "GET",
    },
    addMerchantInfo: {
        name: "add merchant info api",
        version: 6,
        url: "info",
        method: "POST",
    },
    updateMerchantInfo: {
        name: "update merchant info api",
        version: 6,
        url: "info/%{id}",
        method: "PUT",
    },
    getMerchantAccountInfo: {
        name: "get merchant account info api",
        version: 6,
        url: "account/info",
        method: "GET",
    },
    updateMerchantAccountInfo: {
        name: "update merchant account info api",
        version: 6,
        url: "account/info/%{id}",
        method: "PUT",
    },

    getMerchantBasicInfo: {
        name: "get merchant basic info api",
        version: 6,
        url: "basic",
        method: "GET",
    },
    updateMerchantBasicInfo: {
        name: "update merchant basic info api",
        version: 6,
        url: "basic/%{id}",
        method: "PUT",

    },

    getProductGroups: {
        name: "get product groups api",
        version: 6,
        url: "product-groups",
        method: "GET",
    },
    updateProductGroups: {
        name: "update product groups api",
        version: 6,
        url: "product-groups",
        method: "PUT",
    },

    orderDebug: {
        name: "order debug api",
        version: 6,
        url: "order/%{id}/debug",
        method: "GET",
    },
    ocrPrefill: {
        name: "wechat ocr prefill",
        version: 6,
        url: "wechat/ocr/prefill",
        method: "POST",
    },
    bankingProvinces: {
        name: "wechat banking provinces",
        version: 6,
        url: "wechat/banking/provinces",
        method: "GET",
    },
    bankingCities: {
        name: "wechat banking cities",
        version: 6,
        url: "wechat/banking/cities",
        method: "GET",
    },
    bankingPersonalBanks: {
        name: "wechat banking personal banks",
        version: 6,
        url: "wechat/banking/personal-banks",
        method: "GET",
    },
    bankingCorporateBanks: {
        name: "wechat banking corporate banks",
        version: 6,
        url: "wechat/banking/corporate-banks",
        method: "GET",
    },
    bankingBranches: {
        name: "wechat banking branches",
        version: 6,
        url: "wechat/banking/branches",
        method: "GET",
    },
    bankingSearchByAccount: {
        name: "wechat banking search by account",
        version: 6,
        url: "wechat/banking/search-by-account",
        method: "POST",
    },
}